import type { ChartSurfaceState } from '@highereducation/hen-ui';

import type { BoundStatusSurface } from '../boundStatus/resolveBoundStatus';

/** One sentence for both empty reasons. */
export const EMPTY_FRAME_TITLE = 'No data matches your filters';

/**
 * Adapter failures share the query-error surface. The sentence is distinct
 * from the empty title so a configuration defect does not read as no data.
 */
export const ADAPTER_ERROR_MESSAGE =
  'The chart could not be drawn from this data.';

/** Stale banner copy. The host supplies the freshness window. */
export const STALE_FRAME_MESSAGE = 'Data may be older than expected.';

export function toChartSurface(surface: BoundStatusSurface): ChartSurfaceState {
  return surface === 'error' ? 'queryError' : surface;
}
